import { useEffect, lazy, Suspense } from "react";

import { useLocation } from "react-router-dom";
import PodcastPopup from "@/components/layout/PodcastPopup";
import Navigation from "@/components/layout/Navigation";
import Footer from "@/components/layout/Footer";
import HeroSection from "@/components/sections/HeroSection";
import TrustBar from "@/components/sections/TrustBar";
import PowerHourFAB from "@/components/layout/PowerHourFAB";
import WhatsAppButton from "@/components/layout/WhatsAppButton";

// Code-split below-fold sections for faster initial load
const PodcastSection = lazy(() => import("@/components/sections/PodcastSection"));
const FearSection = lazy(() => import("@/components/sections/FearSection"));
const AboutSection = lazy(() => import("@/components/sections/AboutSection"));
const ServicesSection = lazy(() => import("@/components/sections/ServicesSection"));
const BookSection = lazy(() => import("@/components/sections/BookSection"));
const HomeExchangeSection = lazy(() => import("@/components/sections/HomeExchangeSection"));
const LatestFieldNotes = lazy(() => import("@/components/sections/LatestFieldNotes"));
const TestimonialsSection = lazy(() => import("@/components/sections/TestimonialsSection"));
const FAQSection = lazy(() => import("@/components/sections/FAQSection"));
const SectionBreak = lazy(() => import("@/components/sections/SectionBreak"));

const Index = () => {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 100);
      }
    }
  }, [hash]);

  return (
    <div className="min-h-screen bg-background">
      <PodcastPopup />
      <Navigation />
      <main>
        <HeroSection />
        <TrustBar />
        <Suspense fallback={null}>
          <SectionBreak />
          <PodcastSection />
          <FearSection />
          <AboutSection />
          <SectionBreak />
          <TestimonialsSection />
          <ServicesSection />
          <HomeExchangeSection />
          <LatestFieldNotes />
          <SectionBreak />
          <BookSection />
          <FAQSection />
        </Suspense>
      </main>
      <PowerHourFAB />
      <WhatsAppButton />
      <Footer />
    </div>
  );
};

export default Index;
